import React, { Component } from 'react';
import './FormInput.css';

class FormInput extends Component {
  render() {
    let errorMessageIsSet = typeof this.props.errorMessage !== 'undefined';
    return (
      <div className = "FormInput">
        <label>{this.props.label}</label>
        <input type = {this.props.type} placeholder = {this.props.placeholder} value = {this.props.value} onChange = {this.props.onChange}/>
        { errorMessageIsSet &&
          <div className = "FormInputErrorMessage">{this.props.errorMessage}</div>
        }
      </div>
    );
  }
}

export default FormInput;



// WEBPACK FOOTER //
// ./src/ui/FormInput.js